import {DeviceOrientation} from "./DeviceOrientation";

export class Device {

    static get isMobile(): boolean {
        return Device.isiOS || Device.isAndroid;
    }

    static get isiOS(): boolean {
        return navigator.userAgent.match(/iPhone/i) != null ||
            navigator.userAgent.match(/iPad/i) != null ||
            navigator.userAgent.match(/iPod/i) != null || (
                // since iPad is not present in the userAgent for iPad OS 13 an alternative was needed
                navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
            );
    }

    static get iOSVersion(): any {
        if (navigator.userAgent.match(/ipad|iphone|ipod/i)) {
            const version: any = {}
            version.major = +(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0].split('_')[0].replace("OS ","")
            version.full = +(navigator.userAgent).match(/OS (\d)?\d_\d(_\d)?/i)[0].replace("_",".").replace("_","").replace("OS ","")

            return version
        }

        return null
    }

    static get isAndroid(): boolean {
        return navigator.userAgent.match(/Android/i) != null
    }

    static get isCriOS(): boolean {
        return navigator.userAgent.match(/CriOS/i) != null
    }

    static get isChrome(): boolean {
        return navigator.userAgent.match(/Chrome/i) != null
    }

    static get isSafari(): boolean {
        return navigator.userAgent.match(/Safari/i) != null
    }

    static get isFirefox(): boolean {
        return navigator.userAgent.match(/Firefox/i) != null
    }

    static get isIE11(): boolean {
        return !Device.isFirefox && navigator.appName == "Netscape" && navigator.userAgent.match(/Trident/i) != null;
    }

    static get currentOrientation(): DeviceOrientation {
        var orientation = window.screen['orientation'] || window.screen['MozOrientation'];
        if (orientation && orientation.type != undefined) {
            if (orientation.type === "landscape-primary" || orientation.type === "landscape-secondary") {
                return DeviceOrientation.Landscape;
            } else {
                return DeviceOrientation.Portrait;
            }
        } else if (window.orientation != undefined) {
            if (window.orientation == -90 || window.orientation == 90) {
                return DeviceOrientation.Landscape;
            } else {
                return DeviceOrientation.Portrait;
            }
        } else {
            return DeviceOrientation.Landscape;
        }
    }

    static resolveEvent(eventName: string): string {
        const pointerSupport = typeof PointerEvent !== "undefined";
        const supportTouch = typeof Touch !== "undefined";

        if (eventName == "mousedown") {
            if (pointerSupport) {
                eventName = 'pointerdown';
            } else if (supportTouch) {
                eventName = "touchstart";
            }
        } else if (eventName == "mouseup") {
            if (pointerSupport) {
                eventName = 'pointerup';
            } else if (supportTouch) {
                eventName = "touchend";
            }
        } else if (eventName == "mouseupoutside") {
            if (pointerSupport) {
                eventName = 'pointerupoutside';
            } else if (supportTouch) {
                eventName = "touchendoutside";
            }
        } else if (eventName == "mousemove") {
            if (pointerSupport) {
                eventName = 'pointermove';
            } else if (supportTouch) {
                eventName = "touchmove";
            }
        } else if (eventName == "click") {
            if (pointerSupport) {
                eventName = 'pointertap';
            } else if (supportTouch) {
                eventName = "tap";
            }
        }

        return eventName;
    }

    // TODO: make these two getters
    static isSoundSupported(): boolean {
        return Device.getAudioContext() != undefined;
    }

    static getAudioContext(): any {
        if ((window as any).AudioContext)
            return AudioContext;
        else
            return (window as any).webkitAudioContext;
    }

    static scale: number = 1
}
